import React from "react";

import { Logger } from "logging/logger";
import PropTypes from "prop-types";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.logger = new Logger(`${props.tag}ErrorBoundary`);
  }

  static getDerivedStateFromError(error) {
    this.logger.error(error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.logger.error(error, errorInfo);
  }

  _getAdditionalData() {
    return JSON.stringify(this.props.additionalData, null, 2);
  }

  render() {
    if (this.state.hasError) {
      let additionalData = this.props.additionalData ? (
        <p>{this._getAdditionalData()}</p>
      ) : (
        <></>
      );
      return (
        <>
          <h1>
            An error has ocurred and can't render. Please press F12 and see the
            console for details
          </h1>
          <p>
            If the error persists, please contact support and attach a
            screenshot of the console error details and additional data in this
            message if present
          </p>
          {additionalData}
        </>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  additionalData: PropTypes.object,
  tag: PropTypes.string.isRequired,
};
